/* Microsoft browser page measurement for the existing Shopify CAPI tag.
 * Purchases and checkout events remain owned by the Microsoft Shopify app.
 * Do not add a second purchase emitter without verified shared event IDs.
 */
(function () {
  'use strict';
  if (window.__gfMicrosoftUet || (window.Shopify && window.Shopify.designMode)) return;
  // Yield to another integration rather than initializing UET twice.
  if (window.uetq || document.querySelector('script[src*="bat.bing.com/bat.js"],script[src*="bat.bing.net/bat.js"]')) return;
  var state = window.__gfMicrosoftUet = { loaded: false, measured: false };
  var loading = false;
  var attempts = 0;
  window.uetq = [];
  window.uetq.push('consent', 'default', { ad_storage: 'denied' });

  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy &&
      typeof privacy.analyticsProcessingAllowed === 'function' &&
      typeof privacy.marketingAllowed === 'function' &&
      typeof privacy.saleOfDataAllowed === 'function' &&
      privacy.analyticsProcessingAllowed() && privacy.marketingAllowed() &&
      privacy.saleOfDataAllowed());
  }

  function measurePage() {
    if (!state.loaded || state.measured || !allowed()) return;
    state.measured = true;
    window.uetq.push('pageLoad');
  }

  function sync() {
    var consent = allowed();
    window.uetq.push('consent', 'update', { ad_storage: consent ? 'granted' : 'denied' });
    if (!consent) return;
    if (state.loaded) { measurePage(); return; }
    if (loading) return;
    loading = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://bat.bing.net/bat.js?ti=343280661';
    script.onload = function () {
      if (typeof window.UET !== 'function') return;
      window.uetq = new window.UET({ ti: '343280661', enableAutoSpaTracking: false, q: window.uetq });
      state.loaded = true;
      window.uetq.push('consent', 'update', { ad_storage: allowed() ? 'granted' : 'denied' });
      measurePage();
    };
    script.onerror = function () { state.loadError = true; };
    document.head.appendChild(script);
  }

  function ready() {
    if (window.Shopify && window.Shopify.customerPrivacy) { sync(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) sync();
      });
    } else if (++attempts < 20) {
      window.setTimeout(ready, 250);
    }
  }
  document.addEventListener('visitorConsentCollected', sync);
  ready();
}());
